export type Proyecto = {
	id: number;
	name: string;
	poblacionDestinataria: string;
	objetivo: string;
	creador: string;
	impartidoPor?: string;
	colaboradores?: string[]; // Array de strings para varios colaboradores
	protagonistas?: string[]; // Array de strings para varios protagonistas
	image: string; // Ruta relativa o import de StaticImageData
};

const projects: Proyecto[] = [
	{
		id: 1,
		name: "Proyecto Intergrapps",
		poblacionDestinataria:
			"Personas usuarias de la Concejalía de Bienestar Social del Excmo. Ayuntamiento de Arucas",
		objetivo:
			"Adquirir competencias TICs básicas por parte de las personas usuarias de la Concejalía de Bienestar Social que facilite el acceso a aplicaciones digitales que favorezcan su estimulación cognitiva y promuevan su integración social y digital.",
		creador:
			"Aranzazu G. Butler - Trabajadora Social y presidenta de la Asociación Equilibrio",
		impartidoPor:
			"Javier López - Desarrollador web y docente en competencias digitales",
		image: "/assets/proyecto-intergrapps.png",
	},
	{
		id: 2,
		name: "Proyecto Nube",
		poblacionDestinataria: "Empleados/as del Centro Ocupacional de Arucas.",
		objetivo:
			"Adquirir competencias TICs básicas por parte de los/las empleados/as del Centro Ocupacional de Arucas que facilite el acompañamiento y asesoramiento a las personas usuarias y promueva la implementación de herramientas digitales en el mismo.",
		creador:
			"Aranzazu G. Butler - Trabajadora Social y presidenta de la Asociación Equilibrio",
		impartidoPor:
			"Javier López - Desarrollador web y docente en competencias digitales",
		image: "/assets/proyecto-nube.png",
	},
	{
		id: 3,
		name: 'CAMPAÑA "AVANCEMOS JUNTOS"',
		poblacionDestinataria: "General",
		objetivo:
			"Sensibilizar a la población para prevenir y proteger la situación de extrema vulnerabilidad de lxs jóvenes ex-tuteladxs.",
		creador:
			"Aranzazu G. Butler - Trabajadora Social y presidenta de la Asociación Equilibrio",
		colaboradores: [
			"Asociación Asistencial NAHIA y Asociación Jóvenes de Faycan",
			"Videógrafo - Daniel Meana (https://www.danielmeana.com/)",
		],
		protagonistas: [
			"Olamide Hafeed",
			"Iván Romero",
			"Kevín González",
			"Mariama Barry",
		],
		image: "/assets/proyecto-avanzamosJuntos.jpg",
	},
];

export default projects;
